var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"nav-item nav-link",attrs:{"to":"/posts"}},[_c('div',{staticClass:"welcome-wrapper"},[_c('div',{staticClass:"welcome-statement"},[_c('h1',[_vm._v("THE UNIVERSE IS")]),_c('h1',[_vm._v("ALTERED")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }